import { Avatar, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const teamMembers = [
  {
    name: 'Charles Thompson',
    title: 'Chief Executive Officer',
    image: 'images/about/1549427611528.jpeg',
    bio: `Charles Thompson is the Chief Executive Officer of Specialized 247 Property Management, a Dallas-based firm specializing in asset management for single-family rental home portfolios. With 27 years of experience in turnaround management and strategy-based consulting, he has built Specialized into an industry leader across multiple markets with over $600M in assets under management. Charles holds an M.B.A. from Northwestern Kellogg School of Management and a B.A. from Texas Tech University. He is an avid snow skier and golfer and enjoys spending time with his wife and three boys.`
  },
  {
    name: 'Rodd Schifferdecker',
    title: 'President',
    image: 'images/about/1664316818540.jpeg',
    bio: `Rodd Schifferdecker is the President of Specialized Property Management. With extensive experience in the property management industry, Rodd has been instrumental in driving growth and technological advancement within the company. His leadership has positioned Specialized Property Management as a leader in the single-family home rental space.`
  },
  {
    name: 'Nathan Jackson',
    title: 'Vice President of Technology',
    image: 'images/about/1726023173152.jpeg',
    bio: `Nathan Jackson is the Vice President of Technology at Specialized Property Management. He is responsible for the development, implementation, and management of the company's industry-leading Business Intelligence platform, Rentfinder.ai. Nathan received his degree in Finance & Accounting from the University of Arkansas. He enjoys watching Razorback football and Formula 1 racing, and in his free time, he manages multiple servers at home.`
  },
  {
    name: 'Anand Rathna',
    title: 'Chief Troublemaker',
    image: 'images/about/1737247550531.jpg',
    bio: `Anand is the Chief Troublemaker and the visionary tech brain behind RentFinder.ai. With a remarkable career in software development and artificial intelligence, Anand, with his proficient and diverse experience in technology, has led the creation of innovative solutions that have transformed the rental property industry. His expertise in AI-driven platforms has been pivotal in providing precise rental estimates and interactive analysis for property managers and investors. Anand holds multiple degrees in technology and has been a key member in creating this product.`
  }
];

const About = () => {
  const [hovered, setHovered] = useState<number | null>(null);

  useEffect(() => {
    let currentIndex = 0;
    let cycles = 0;
    const totalCycles = 3;
    const hoverInterval = setInterval(() => {
      setHovered(currentIndex);
      currentIndex++;
      if (currentIndex >= teamMembers.length) {
        currentIndex = 0;
        cycles++;
        if (cycles >= totalCycles) {
          clearInterval(hoverInterval);
          setHovered(null);
        }
      }
    }, 500);
    return () => clearInterval(hoverInterval);
  }, []);

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Meet Our Team
      </Typography>
      <Grid container spacing={4} sx={{ marginTop: 5 }}>
        {teamMembers.map((member, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Card
              onMouseEnter={() => setHovered(index)}
              onMouseLeave={() => setHovered(null)}
              sx={{
                boxShadow: hovered === index ? 10 : 2,
              }}
            >
              <CardContent>
                <Avatar
                  alt={member.name}
                  src={member.image}
                  sx={{
                    width: 200,
                    height: 200,
                    margin: 'auto',
                    filter: hovered === index ? 'none' : 'grayscale(100%)',
                    transform: hovered === index ? 'scale(1.2)' : 'scale(1)',
                    transition: 'filter 0.4s ease 0s, transform 0.4s ease 0s',
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                />
                <Typography variant="h4" align="center" gutterBottom>
                  {member.name}
                </Typography>
                <Typography variant="subtitle1" align="center" color="textSecondary" gutterBottom>
                  {member.title}
                </Typography>
                <Typography variant="body1" align="justify">
                  {member.bio}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default About;
